import type { OverlayProps } from './Overlay.typed';
import { useCallback, useEffect, useState } from 'react';
import Portal from '../Portal/Portal';
import { useOnClickOutside, useOnPressEscape, useFocusTrap } from 'hooks';

// TODO: create hooks for different logic e.g. clickOutside, onEscape/onKeyDown
const Overlay = (props: OverlayProps) => {
  const {
    shouldTrapFocus,
    returnFocusRef,
    onClickOutside,
    onEscape,
    ignoreClickRefs,
    children,
  } = props;
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const containerRef = useCallback((element: HTMLDivElement) => {
    setContainer(element);
  }, []);

  useOnPressEscape({
    onEscape,
  });
  useOnClickOutside({ onClickOutside, container, ignoreClickRefs });
  const { trapFocus, unTrapFocus } = useFocusTrap({ container });

  useEffect(() => {
    if (container && shouldTrapFocus) {
      trapFocus();
    }
    const returnFocus = returnFocusRef?.current;
    return () => {
      if (container && shouldTrapFocus) {
        unTrapFocus(returnFocus);
      }
    };
    // TODO: Clean up this effect's dependencies. We're disabling this lint error for now so we can
    // clean up the lint logs. Ideally we should rewrite this code to be less error prone and trust
    // the lint rule's judgement.
    // https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=userstory/98606
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [container]);

  return (
    <Portal>
      <div
        ref={containerRef}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999999999,
        }}
      >
        {children}
      </div>
    </Portal>
  );
};

export default Overlay;
